/*
 * @Author: wangjiaxin@leedarson.com
 * @Date: 2019-12-17 10:59:16
 * Copyright © Leedarson. All rights reserved.
 */
let _zIndex = 5000;

const getZIndex = () => {
  return _zIndex;
};

const increaseZIndex = () => {
  _zIndex += 1;
};

const resetZIndex = () => {
  _zIndex = 5000;
};

export { getZIndex, increaseZIndex, resetZIndex };
